import { useEffect, useState } from 'react';
import { type Agency } from '../../../common/types';
import { AiOutlineClose } from 'react-icons/ai';
import { extractErrorsFromApi } from '../../../common/helpers';
import RenderErrorBag from '../../../components/render-error-bag';
import { toast } from 'react-toastify';
import { useDeleteAgencyByIdMutation } from '../agency.api-slice';
import { useTranslation } from 'react-i18next';

interface IProps {
  isOpen: boolean;
  toggleDeleteModal: () => any;
  item: Agency | null;
}

const DeleteAgency: React.FC<IProps> = ({ item, isOpen, toggleDeleteModal }) => {
  const [deleteItem, { isSuccess, isLoading, isError, error, reset }] = useDeleteAgencyByIdMutation();
  const [errorBag] = useState<string[]>([]);
  const { t } = useTranslation();

  const handleDeleteItem = (): void => {
    if (item?.id == null) {
      return;
    }
    void deleteItem(item.id);
    toggleDeleteModal();
  };

  useEffect(() => {
    if (isSuccess) {
      toast(t('agencies.delete.successMessage'));
      reset();
    }
    if (isError && error != null) {
      toast.error(extractErrorsFromApi(error)[0]);
      reset();
    }
  }, [isSuccess, error]);

  return (
    <>
      {isOpen && item != null ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="my-6 mx-auto w-1/2">
              <div className="border-0 rounded-lg shadow-lg flex flex-col bg-white outline-none focus:outline-none">
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 data-cy="delete-agency-modal-title" className="text-3xl font-semibold">
                    {t('agencies.delete.title')}
                  </h3>
                  <button
                    className="p-1 ml-auto border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={toggleDeleteModal}
                  >
                    <AiOutlineClose size={20} />
                  </button>
                </div>
                <div className="relative p-6 flex-auto w-full">
                  {errorBag.length > 0 && <RenderErrorBag errorBag={errorBag} />}
                  {t('agencies.delete.body')}
                </div>
                <div className="w-full flex justify-end px-4 space-x-2 py-6 mt-4 border-t border-solid border-slate-200 rounded-b">
                  <button className="text-black px-5 py-2 rounded-lg bg-gray-200" onClick={toggleDeleteModal}>
                    {t('agencies.delete.cancelBtnLabel')}
                  </button>
                  <button
                    disabled={isLoading}
                    data-cy="delete-agency-confirm-btn"
                    onClick={handleDeleteItem}
                    className="text-white px-4 py-2 rounded-lg bg-[#1D8A43]"
                  >
                    {t('agencies.delete.saveBtnLabel')}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default DeleteAgency;
